import StopIcon from '@mui/icons-material/Stop';
import { IconButton, useTheme } from '@mui/material';

interface StopSpeakingButtonProps {
    stopSpeaking: () => void;
}

const StopSpeakingButton = ({ stopSpeaking }: StopSpeakingButtonProps) => {
    const theme = useTheme();

    return (
        <IconButton
            onClick={stopSpeaking}
            aria-label='Stop speaking'
            sx={{ boxShadow: theme.customShadows.primaryGradient, p: 2.5 }}
        >
            <StopIcon sx={{ color: 'white', width: 24, height: 24 }} />
        </IconButton>
    );
};

export default StopSpeakingButton;
